import React, { Fragment, useEffect, useState } from 'react';

import { api } from '../api';
import { ListGroup } from 'react-bootstrap';
import { ItemReviewListItem } from './ItemReview';
import { VendorFeature } from './SignedOutDynamicHome';


function ItemReviewListItems(props) {
    if(!props.reviews) {
        return <Fragment></Fragment>;
    }
    return props.reviews.map(review => (
        <ListGroup.Item key={review.id} style={{display: "inline-block", paddingLeft: "0px", paddingRight: "0px", paddingBottom: "0px", marginBottom: "48px"}}>
            <ItemReviewListItem review={review} showItemLink={true} showUserLink={true} showVendorLink={true} showVendorMap={true} showFullReview={false}/>
        </ListGroup.Item>
    ));
}

function ItemReviewList(props) {
    if(!props.reviews) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
            <ListGroup style={{maxWidth: "1002px"}}>
                <ItemReviewListItems reviews={props.reviews}></ItemReviewListItems>
            </ListGroup>
        </Fragment>
    );
}

function ItemReviewListLoader(props) {
    const [reviews, setReviews] = useState(null);

    useEffect(() => {
        api.listReviews({ limit: 10 }).then((page) => setReviews(page.items)).catch(() => setReviews([]));
    }, []);

    if(!reviews) {
        return <Fragment></Fragment>;
    }
    return (
        <div>
            <div style={{display: "flex", maxWidth: "1002px", alignItems: "center"}} >
                <h1 style={{display: "inline-block", flexGrow: "2"}}>{props.headerText}</h1>
                <VendorFeature></VendorFeature>
            </div>
            <ItemReviewList reviews={reviews}></ItemReviewList>
        </div>
    );
}

export { ItemReviewListLoader };
